import React, { Fragment, useState } from "react";
import Translator from "Languages/Utility/Translator";
import { useDispatch } from "react-redux";
import AuthHeader from "../components/AuthHeader";
import Input from "Components/Input/Input";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import { useSetState } from "Helpers/Hooks";
import { push } from "Helpers/History";
import { VERIFY_TYPE } from "Stores/actionTypes";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
// import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import AuthService from "Services/http/endpoints/AuthService";
import StatusHandler from "Helpers/StatusHandler";
import { useTranslation } from "react-i18next";

// function ForgetPassword(props) {
function ForgetPassword() {
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [state, setState] = useSetState({
    phone: {
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhone: true,
        minLength: 11,
      },
    },
  });

  const onReturnLogin = () => push("/");

  const onResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { phone } = state;
    const enPhone = convertToEnglishNumber(phone.value);
    const phoneWithCode = enPhone.replace("0", "+98");
    if (formValid) {
      const token = ""; // await props.googleReCaptchaProps?.executeRecaptcha();
      const data = {
        Value: phoneWithCode,
        Type: 2,
        keyCap: token,
      };
      const response = await AuthService.authResetPassword(data);
      let err = StatusHandler(response);
      let _Header = { Authorization: `Bearer ` };
      if (!err.isFail) {
        if (response.data.StatusCode === 222) {
          _Header = { Authorization: `Bearer ${response.data.Value.Token}` };
        }
        dispatch({
          type: VERIFY_TYPE,
          userId: phoneWithCode,
          verifyType: "resetPassword",
          verifyData: "",
          header: _Header,
        });
        push("/auth/verify");
      }
      // dispatch({
      //   type: VERIFY_TYPE,
      //   userId: phoneWithCode,
      //   verifyType: "resetPassword",
      //   verifyData: "",
      //   keyCap: token,
      // });
      //push("/auth/verify");
    } else {
      showNotify({
        text: t("invalidNumber"),
        customClass: "error",
      });
    }
    setLoading(false);
  };

  const setValue = (name, value, validation) => {
    setState({ [name]: { value: value } });
    setFormValid(validation);
  };

  return (
    <Fragment>
      <AuthHeader
        title={t("header_password_recovery")}
        // description={<Translator id="err_mobileIsNull" />}
      />
      <form onSubmit={onResetPassword} className="mt-4">
        <div className="authForm ">
          <Input
            className="phone"
            setValue={setValue.bind(this)}
            value={state.phone.value}
            name="phone"
            validation={state.phone.validation}
            label={<Translator id="err_mobileIsNull" />}
            type="text"
            fullWidth
            helperText={"mobileExample"}
            maxlength="11"
          />
        </div>
        <div className="d-flex justify-content-center my-3">
          <MuiButton
            color="primary"
            loading={loading}
            type="submit"
            className="w-100"
            title={<Translator id="resetPassword" />}
          />
        </div>
        <div className="d-flex justify-content-center ">
          <MuiButton
            className="link"
            onClick={onReturnLogin}
            title={<Translator id="button_return_login" />}
          />
        </div>
      </form>
    </Fragment>
  );
}

export default ForgetPassword;
// export default withGoogleReCaptcha(ForgetPassword);
